<template lang="pug">
.content-inner
    .header
      h1.title {{ $t('settings_tab.admin_tab.customer_tab.title') }}
    aiq-collapse.scrollbar__collapse(accordion)
      aiq-collapse-item(title="Segments")
        segments
      .celebration
        aiq-collapse
          aiq-collapse-item(title="Personal pop-up")
            celebration
      .feedback
        aiq-collapse
          aiq-collapse-item(title="Feedback")
            feedback-interval
            feedback-display-duration
      .banner-and-interstitial-message
        aiq-collapse
          aiq-collapse-item(title="Banner and interstitial message")
            banner-and-interstitial-message
</template>

<script>
import Segments from './Segments/Manage.vue';
import Celebration from './Celebration/Manage.vue';
import FeedbackInterval from './FeedbackInterval/FeedbackInterval.vue';
import FeedbackDisplayDuration from './FeedbackDisplayDuration/FeedbackDisplayDuration.vue';
import BannerAndInterstitialMessage from './BannerAndIntersistalMessage/index.vue';
import { mapState } from 'vuex';
export default {
  name: 'customer-tab',
  components: {
    Segments,
    Celebration,
    FeedbackInterval,
    FeedbackDisplayDuration,
    BannerAndInterstitialMessage,
  },
  computed: {
    ...mapState({
      featureFlags: state => state.featureFlags.FEATURE_FLAGS,
    }),
  },
};
</script>

<style lang="scss" scoped>
.content-inner {
  max-height: calc(100vh - 204px);
  overflow-y: auto;
}
</style>
